
export function Label(props: {
	title: string,
	isRequired?: boolean,
	className?: string,
	onClick?: (e: any) => void,
}) {

	return (
		<label
			className={props.className}
			onClick={props.onClick}
		>
			{props.title}
			{props.isRequired ? <span className="required">*</span> : undefined}
		</label>
	);
}